"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubpageProperty = exports.subpagePropertyDefinition = void 0;
exports.subpagePropertyDefinition = {
    view: { label: 'Subpage' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: ['subpage-label', 'subpage-asset'],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'subpage',
};
const isSubpageProperty = (prop) => {
    return prop.name === exports.subpagePropertyDefinition.name;
};
exports.isSubpageProperty = isSubpageProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3VicGFnZS5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3N1YnBhZ2UucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSx5QkFBeUIsR0FBRztJQUN2QyxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsU0FBUyxFQUFFO0lBQzFCLFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLG1CQUFtQjtZQUN6QixRQUFRLEVBQUUsQ0FBQyxlQUFlLEVBQUUsZUFBZSxDQUFDO1NBQzdDO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsbUJBQW1CO0lBQ3pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLFNBQVM7Q0FDZ0IsQ0FBQTtBQUkxQixNQUFNLGlCQUFpQixHQUFHLENBQUMsSUFBa0IsRUFBMkIsRUFBRTtJQUMvRSxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssaUNBQXlCLENBQUMsSUFBSSxDQUFBO0FBQ3JELENBQUMsQ0FBQTtBQUZZLFFBQUEsaUJBQWlCLHFCQUU3QiJ9